import React, { useState, useEffect } from "react";

function OHTd({ dataHeader, onClick, activeTime, deactiveTime, edit }: any) {
  const [active, setactive] = useState(false);
const [disable, setdisable] = useState(false);
  useEffect(() => {
    setactive(activeTime);
    setdisable(deactiveTime);
  }, [activeTime, deactiveTime]);

  const handleClick = () => {
    // if (edit) {
    //   setactive(!active);
    //   onClick({ ...dataHeader, active: !active });
    // }
       setdisable(!disable);
    onClick({
      ...dataHeader,
      active: !disable,
    });
  };

  return (
    <td className="px-2 py-2 text-center">
      <button
        onClick={() => edit && active && handleClick()}
        // disabled={!edit}
        className={`w-8 h-8 rounded-lg transition-all ${active ? (disable ? "bg-purple-500 shadow-md shadow-purple-200" : "bg-blue-500 shadow-md shadow-blue-200") : "bg-slate-200" }` }
       
      />
    </td>
  );
}

export default OHTd;
